$('.custom-range').each(function () {
    let $input = $(this).find('.custom-range__input'),
        $output = $(this).find('.custom-range__output'),
        min = $input.attr('min'),
        max = $input.attr('max');

    $input.on('input', function () {
        let currentVal = $input.val();

        // update current value in output element
        $output.val(currentVal);

        // update position of output element
        let offset = ((currentVal - min) / (max - min)) * 100;
        $output.css('left', offset + '%');
    });

    $input.trigger('input'); // set output value + position on pageload if browser remembers value
});